import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { VideoEditor } from '@/features/youtube-studio/video-editor';

export function TutorAdminYoutubeNewPage() {
  return (
    <div className="mx-auto max-w-5xl p-4 sm:p-6">
      <Link
        to="/tutor/admin/youtube"
        className="text-ink-500 hover:text-ink-900 mb-4 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        YouTube Studio
      </Link>
      <h1 className="font-display text-ink-900 mb-5 text-2xl font-extrabold tracking-tight">
        Nouvelle vidéo
      </h1>
      <VideoEditor />
    </div>
  );
}
